/* Revive: Shopify's instant search suggestions don't support Hebrew, so on the Hebrew site the
   search window stayed empty while typing. This adds a "show all results" link to the full search page. */
(function () {
  if ((document.documentElement.lang || '').slice(0, 2) !== 'he') return;
  function setup() {
    var input = document.getElementById('cmdk-input');
    if (!input || input.dataset.reviveHint) return;
    input.dataset.reviveHint = '1';
    var form = input.closest('form');
    if (!form) return;
    var tpl = document.documentElement.getAttribute('data-revive-search-hint') || '“{{ q }}”';
    var root = document.documentElement.getAttribute('data-revive-root') || '/';
    var hint = document.createElement('a');
    hint.className = 'revive-search-hint';
    hint.hidden = true;
    var header = form.querySelector('.predictive-search-form__header');
    if (header) header.after(hint); else form.prepend(hint);
    function update() {
      var q = input.value.trim();
      if (!q) { hint.hidden = true; return; }
      hint.href = root.replace(/\/$/, '') + '/search?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last';
      hint.textContent = tpl.replace('{{ q }}', q);
      hint.hidden = false;
    }
    input.addEventListener('input', update);
    update();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup); else setup();
})();
